import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const PointsFrameHeader = styled(Typography.TextH4_20_28)(
    ({ theme: { font } }) => css`
        font-family: ${font.primary};
        margin-bottom: 24px;
    `,
);

export const PointsFrameList = styled.ul`
    list-style: none;
    margin: 0;
    padding-left: 16px;
`;

export const PointsFrameItem = styled.li(
    ({ theme: { palette, radius } }) => css`
        margin-bottom: 16px;
        position: relative;

        &:before {
            background: ${palette.secondary.default};
            border-radius: ${radius[50]}%;
            content: '';
            height: 6px;
            left: -13px;
            position: absolute;
            top: 7px;
            width: 6px;
        }

        &:last-of-type {
            margin: 0;
        }
    `,
);

export const PointsFrameText = styled(Typography.TextBody_16_24)``;
